import React, { useEffect, useState } from "react";
import AdminHeader from "./AdminHeader";
import Icon from "../common/Icon";

export default function DashboardLayout({
  children,
  SidebarComponent,
}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMobileOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const renderSidebar = (mobile = false) => (
    <SidebarComponent
      collapsed={mobile ? false : collapsed}
      mobile={mobile}
      onToggle={() => {
        if (mobile) {
          setMobileOpen(false);
        } else {
          setCollapsed((value) => !value);
        }
      }}
    />
  );

  return (
    <div
      dir="rtl"
      className="dash-shell flex min-h-screen gap-3 p-0 md:p-3"
    >
      {/* Desktop Sidebar */}
      <aside className="sticky top-3 hidden h-[calc(100vh-1.5rem)] shrink-0 md:block">
        {renderSidebar(false)}
      </aside>

      {/* Mobile Sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 z-[100] flex md:hidden">
          <div className="relative z-10 h-full p-2">
            {renderSidebar(true)}
          </div>

          <button
            type="button"
            aria-label="بستن منو"
            onClick={() => setMobileOpen(false)}
            className="flex-1 cursor-default bg-ink/60 backdrop-blur-md"
          />
        </div>
      )}

      {/* Main */}
      <div className="flex min-w-0 flex-1 flex-col">
        <AdminHeader
          collapsed={collapsed}
          onMenuClick={() => setMobileOpen(true)}
        />

        <main className="min-w-0 flex-1 px-3 pb-6 pt-4 sm:px-4 lg:px-6">
          <div className="mx-auto w-full max-w-[1800px]">
            {children}
          </div>
        </main>
      </div>

      {/* Mobile close helper */}
      {mobileOpen && (
        <button
          type="button"
          onClick={() => setMobileOpen(false)}
          className="fixed bottom-5 left-5 z-[110] grid h-11 w-11 place-items-center rounded-full bg-floodlight text-ink shadow-lime md:hidden"
          aria-label="بستن"
        >
          <Icon name="close" className="h-5 w-5" />
        </button>
      )}
    </div>
  );
}